import { render, staticRenderFns } from "./GenAiBreakdownModal.vue?vue&type=template&id=24dc54fa&"
import script from "./GenAiBreakdownModal.vue?vue&type=script&lang=ts&"
export * from "./GenAiBreakdownModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports